module.exports = __webpack_public_path__ + "img/ey-logo.a2016b96.png";